module.exports = __webpack_public_path__ + "static/media/event_warning.e90418f5.png";